import { IconButton, Tooltip } from '@material-ui/core';
import AssignmentIcon from '@material-ui/icons/Assignment';
import CachedIcon from '@material-ui/icons/Cached';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import MaterialTable, { Column } from 'material-table';
import { observer, useLocalStore } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Conteudo, NewBody } from '../../../components/Body';
import Botao from '../../../components/Botoes/Botao';
import { Flex } from '../../../components/NavBar/styles';
import Select from '../../../components/Select';
import { newConfigRacoes } from '../../../components/Tabela';
import GetAppIcon from '@material-ui/icons/GetApp';
import Formatter from '../../../services/Formatter';
import useStore from '../../../services/hooks/useStore';
import { apiMain, aqReports } from '../../../services/utils';
import useModal from '../../../services/hooks/useModal';
import SelecionarLoteTanques from './crescimento/SelecionarLoteTanques';
import SelecionarLote from './crescimento/SelecionarLote';
import { permissoes } from '../../../services/utils/permissoes';

const ListagemMortalidade: React.FC = () => {
  const store = useStore();

  const modalSelecionarLote = useModal();
  const modalTanques = useModal();

  const history = useHistory();
  store.propriedade && store.validarPermissao(permissoes.PAINEL_ZOOTECNICO_LEITURA, history);

  const state = useLocalStore(() => ({
    lote: null as SelectRow | null,
    tanque: null as SelectRow | null,
    causa: null as SelectRow | null,
    especie: null as SelectRow | null,
    codigo: '',
    id: {
      lote: null as any,
      tanque: null as any,
    },
    data_ini: null as MaterialUiPickersDate,
    data_fim: null as MaterialUiPickersDate,

    lotes: [] as SelectRow[],
    tanques: [] as SelectRow[],

    rows: [] as object[],
    totais: 0,
    sync: false,
  }));
  const columns: Column<object>[] = [
    {
      field: 'data',
      title: 'Data',
    },
    {
      field: 'lote.codigo',
      title: 'Lote',
    },
    {
      field: 'tanque.nome',
      title: 'Tanque',
    },
    {
      field: 'especie.nome',
      title: 'Espécie',
    },
    {
      field: 'fase_lote.nome',
      title: 'Fase',
    },
    {
      field: 'tipo_morte.nome',
      title: 'Motivo',
    },
    {
      field: 'quantidade',
      title: 'Quantidade',
      type: 'numeric',
      render: (rowData: any) => {
        return Formatter.formatNumber(0, rowData.quantidade);
      },
    },
  ];

  async function sync(): Promise<void> {
    store.toggleLoader();
    await store.tiposDeMorte.populate();
    await store.lotes.populate();
    await store.loteTanque.populate();
    await store.especies.populate();

    state.lotes = store.lotes.map((item) => {
      return {
        label: item.nome,
        value: item.uuid,
      };
    });

    state.tanques = store.loteTanque.map((item) => {
      return {
        label: item.tanque.nome ? item.tanque.nome : item.tanque.codigo,
        value: item.uuid,
      };
    });

    state.sync = true;

    store.toggleLoader();
  }

  async function getRelatorio(): Promise<void> {
    store.toggleLoader();
    try{
      const response = await aqReports.get(`/mortalidade/${store.propriedade!.uuid}/listagem`, {
        params: {
          lote: state.lote ? state.lote.value : '',
          especie: state.especie ? state.especie.value : '',
          morte: state.causa ? state.causa.value : '',
          lotetanque: state.tanque ? state.tanque.value : '',
          data_inicio: state.data_ini ? Formatter.dateToString(state.data_ini, '/') : undefined,
          data_fim: state.data_fim ? Formatter.dateToString(state.data_fim, '/') : undefined,
        },
      });

      state.rows = response.data.results;
      state.totais = response.data.total;
    } catch(e){
      store.notificar('Não foi possível gerar o relatório. Por favor, tente novamente.')
    } finally {
      store.toggleLoader();
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  async function getCSV() {
    try {
      const pdf = await apiMain.get(`/gerador/csv/mortalidade/${store.propriedade?.id}/listagem`, {
        params: {
          authori: store.token,
          lote: state.lote ? state.lote.value : undefined,
          especie: state.especie ? state.especie.value : undefined,
          morte: state.causa ? state.causa.value : undefined,
          lotetanque: state.tanque ? state.tanque.value : undefined,
          data_inicio: state.data_ini ? Formatter.dateToString(state.data_ini, '/') : undefined,
          data_fim: state.data_fim ? Formatter.dateToString(state.data_fim, '/') : undefined,
        },
      });
      window.open(pdf.request.responseURL, '_blank');
    } catch {
      store.notificar('Houve algum problema ao gerar o PDF! Favor entrar em contato com o Suporte.');
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  async function getPDF() {
    try {
      const pdf = await apiMain.get(`/gerador/pdf/mortalidade/${store.propriedade?.id}/listagem`, {
        params: {
          authori: store.token,
          lote: state.lote ? state.lote.value : undefined,
          especie: state.especie ? state.especie.value : undefined,
          morte: state.causa ? state.causa.value : undefined,
          lotetanque: state.tanque ? state.tanque.value : undefined,
          data_inicio: state.data_ini ? Formatter.dateToString(state.data_ini, '/') : undefined,
          data_fim: state.data_fim ? Formatter.dateToString(state.data_fim, '/') : undefined,
        },
      });
      window.open(pdf.request.responseURL, '_blank');
    } catch {
      store.notificar('Houve algum problema ao gerar o PDF! Favor entrar em contato com o Suporte.');
    }
  }

  function limparFiltros(): void {
    state.especie = null;
    state.causa = null;
    state.lote = null;
    state.tanque = null;
    state.data_ini = null;
    state.data_fim = null;
    state.rows = [];
    state.totais = 0;
  }

  // eslint-disable-next-line
  useEffect(() => store.setTitulo('Listagem de Mortalidades'), []);

  useEffect(() => {
    store.propriedade && sync();
    // eslint-disable-next-line
  }, [store.propriedade]);

  return state.sync ? (
    <NewBody>
      <Flex style={{ justifyContent: 'space-between' }}>
        <Link
          to={'/relatorios/relatorios-zootecnicos'}
          style={{ color: '#049CE7', textDecoration: 'none', fontFamily: 'Roboto' }}
        >
          <Flex>
            <img src={'/images/returnArrow.svg'} />
            <div style={{ paddingLeft: '5px', fontFamily: 'Roboto', color: '#049CE7' }}>Lista de Relatórios</div>
          </Flex>
        </Link>

        <h2>
          Lote/Tanque: {state.lote ? `Lote:  ${state.lote.label}` : ''}{' '}
          {state.tanque ? `Lote:  ${state.codigo} ${'-'} Tanque:  ${state.tanque.label}` : ''}{' '}
        </h2>

        <Flex>
          <Tooltip title="Exportar para CSV">
            <IconButton className="blue" onClick={getCSV}>
              <GetAppIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Baixar PDF">
            <IconButton className="blue" onClick={getPDF}>
              <AssignmentIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Sincronizar">
            <IconButton
              className="blue"
              onClick={() => {
                sync();
                getRelatorio();
              }}
            >
              <CachedIcon />
            </IconButton>
          </Tooltip>
        </Flex>
      </Flex>

      <div style={{ display: 'grid', gridTemplateColumns: '300px 1fr', gap: 10 }}>
        <Conteudo>
          <div style={{ width: '100%', marginBottom: 10 }}>
            <Botao disabled={state.tanque !== null} onClick={() => modalSelecionarLote.open()}>
              Escolha um Lote
            </Botao>
          </div>

          <div style={{ width: '100%', marginBottom: 10 }}>
            <Botao disabled={state.lote !== null} onClick={() => modalTanques.open()}>
              Escolha um Tanque
            </Botao>
          </div>
          <Select
            value={state.especie}
            placeholder="Escolha uma Espécie"
            onChange={(e: any) => (state.especie = e)}
            options={store.especies.getSelectRows2()!}
          />
          <Select
            value={state.causa}
            placeholder="Escolha um Motivo"
            onChange={(e: any) => (state.causa = e)}
            options={store.tiposDeMorte.getSelectRows2()}
          />

          <KeyboardDatePicker
            autoOk
            disableToolbar
            variant="inline"
            format="dd/MM/yyyy"
            margin="normal"
            label="Data Inicial"
            value={state.data_ini}
            onChange={(date) => (state.data_ini = date!)}
            style={{ width: '100%' }}
          />

          <KeyboardDatePicker
            autoOk
            disableToolbar
            variant="inline"
            format="dd/MM/yyyy"
            margin="normal"
            label="Data Final"
            value={state.data_fim}
            onChange={(date) => (state.data_fim = date!)}
            style={{ width: '100%' }}
          />

          <Botao onClick={getRelatorio} cor="#00C853">
            Gerar Relatório
          </Botao>
          <Botao onClick={limparFiltros} cor="#FC7467">
            Limpar Filtros
          </Botao>
        </Conteudo>
        <Conteudo style={{ padding: 0 }}>
          <MaterialTable
            columns={columns}
            data={state.rows}
            options={{
              ...newConfigRacoes.options,
              paging: false,
            }}
            localization={newConfigRacoes.localization}
            style={newConfigRacoes.style}
          />
          <Flex
            style={{
              width: '100%',
              padding: '1rem',
              justifyContent: 'space-between',
              alignItems: 'center',
              margin: '0 auto',
              marginBottom: '-15px',
              border: '1px solid #999',
            }}
          >
            <p>TOTAL GERAL</p>

            <strong>{Formatter.formatNumber(0, state.totais)} </strong>
          </Flex>
        </Conteudo>

        {/* <Conteudo overflowY>
          <ReactApexChart options={graficoDonut.options} series={graficoDonut.series} type="donut" height="300px" />
        </Conteudo> */}
      </div>

      <SelecionarLote
        state={state}
        open={modalSelecionarLote.state}
        handleClose={modalSelecionarLote.close}
        onItemClick={(lote) => {
          state.tanques = [];
          state.lote = { label: lote.codigo, value: lote.uuid };
          state.id = {
            lote: lote.id,
            tanque: '',
          };
        }}
        loteID={state.lote ? parseInt(state.lote.value) : null}
      />

      <SelecionarLoteTanques
        open={modalTanques.state}
        handleClose={modalTanques.close}
        setTanque={(tanque) => {
          state.tanque = { label: tanque.label, value: tanque.value };
          state.id = {
            lote: '',
            tanque: tanque.loteTanque,
          };
          state.codigo = tanque.tanque;
        }}
        setLote={(lote) => console.log(lote)}
        state={state}
        exclude={[]}
      />
    </NewBody>
  ) : null;
};

export default observer(ListagemMortalidade);
